// apps/client/src/ui/hud/ClockPill.tsx — top-left: weekday and town time (12-hour), from WorldSlice.clock
import { tuning, type StringKey } from '@whiskerton/content';
import { useGame } from '../../state/store';
import { useT } from '../i18n';
import { Pill } from '../kit';
import { Moon, Sun } from './Icons';

/** 12-hour parts of a minute of the day: 0 → 12:00 AM, 780 → 1:00 PM. */
export function clockParts(minuteOfDay: number): { h: number; mm: string; pm: boolean } {
  const h24 = Math.floor(minuteOfDay / 60) % 24, m = minuteOfDay % 60;
  return { h: h24 % 12 === 0 ? 12 : h24 % 12, mm: String(m).padStart(2, '0'), pm: h24 >= 12 };
}
/** Night for the clock glyph: from the dusk preset until the morning one (the lighting schedule in tuning.time). */
export function isNight(minuteOfDay: number): boolean {
  const s = tuning.time.presetStarts, m = ((minuteOfDay % 1440) + 1440) % 1440;
  return m < s.morning || m >= s.dusk;
}
export function ClockPill() {
  const t = useT();
  const clock = useGame((s) => s.clock);
  const { h, mm, pm } = clockParts(clock.minuteOfDay);
  const night = isNight(clock.minuteOfDay);
  return (
    <div data-hud className="hud-raised" style={{ position: 'absolute', left: 'calc(var(--hud-inset) + env(safe-area-inset-left))', top: 'calc(var(--hud-inset) + env(safe-area-inset-top))' }}>
      <Pill icon={<span data-glyph={night ? 'moon' : 'sun'} style={{ display: 'inline-flex' }}>{night ? <Moon /> : <Sun />}</span>}>
        <span className="num">{t('time.clock', { weekday: t(`time.weekday${clock.weekday}` as StringKey), h, mm, ampm: t(pm ? 'time.pm' : 'time.am') })}</span>
      </Pill>
    </div>
  );
}
